const apiSettings = {
  ICAS_API_URL:
    process.env.REACT_APP_ICAS_API_URL || 'https://staging.icas.formaloo.com',
  ICAS_AUTHORIZATION_URL: `${process.env.REACT_APP_ICAS_API_URL}/v1/profiles/authorize/`,
  ICAS_API_KEY:
    process.env.REACT_APP_ICAS_API_KEY ||
    '4638feb8378ac5799d6200889f97f2d3d88b9852',
  BUILD_BASE_URL:
    process.env.REACT_APP_DOMAIN || `https://staging.formaloo.com`,
  BUILD_DOMAIN: process.env.REACT_APP_DOMAIN || `https://staging.formaloo.com`,
  APIKEY:
    process.env.REACT_APP_API_KEY || `f0a5ce1ecc1fea87a57f06a52a8e12c48cb16d34`,
  APIURL: process.env.REACT_APP_API_URL || `https://api.staging.formaloo.com`,
  baseUrl: process.env.REACT_APP_DOMAIN || `https://staging.formaloo.com`,
  redirectUri:
    process.env.REACT_APP_ICAS_REDIRECT_URI ||
    `${window.location.origin}/oauth2/exchange/`,
  npsWidgetDomain:
    process.env.REACT_APP_NPS_WIDGET_DOMAIN ||
    `https://staging.widget.formaloo.com`,
  chatbotWidgetDomain:
    process.env.REACT_APP_CHATBOT_WIDGET_DOMAIN ||
    `https://staging.chatbot.formaloo.com`,
  appUiDomain:
    process.env.REACT_APP_APPUI_DOMAIN || 'https://staging.app.formaloo.com',
  googleApiKey:
    process.env.REACT_APP_GOOGLE_API_KEY ||
    'AIzaSyDj0ZpFFRD3Qw22vaEQ4qXC78aL-5_O544',
  intercomApiUrl: 'https://api-iam.intercom.io',
}
export default apiSettings
